// common
export const PUT_REQUEST = 'appointmentAppoint/PUT_REQUEST'
export const PUT_SUCCESS = 'appointmentAppoint/PUT_SUCCESS'
export const PUT_FAILURE = 'appointmentAppoint/PUT_FAILURE'